// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__127bc","container":"styles_container__CNgED","title":"styles_title__8l8O2","wrapper":"styles_wrapper__3gLTe","answer":"styles_answer__35wzY"};